import { IconArrowLeft } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import moment from "moment";
import B2BButton from "../components/common/B2BButton";
import SalesHeader from "./SalesHeader";
import SalesOrderPayment from "./SalesOrderPayment";
import SalesOrderTable from "./SalesOrderTable";
import { createB2BAPI } from "../api/Interceptor";
import DeliveryScheduleModal from "./DeliveryScheduleModal";
import DeliveryScheduleForm from "./DeliveryScheduleForm";
import { useMediaQuery } from "@mantine/hooks";
import { Button, Input, Modal, NumberInput, Popover, Text } from "@mantine/core";
import notify from "../utils/Notification";
import SalesOrderTableFuture from "./SalesOrderTableFuture";
import SalesHeaderTable from "./SalesHeaderTable";
import Logistics from "./Logistics";
import { use } from "react";
import GeDetails from "./GeDetails";
import { text } from "@fortawesome/fontawesome-svg-core";

const PurchaseView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { poId, asnId } = location.state || {};
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const activeTabTop = location.state?.activeHeader;
  const selectedStatusType = location.state?.selectedStatusType;
  console.log(selectedStatusType, "selectedStatusTypemk ")
  const orderType = location?.state?.orderType;
  const [purchaseOrder, setPurchaseOrder] = useState({});
  console.log(selectedStatusType, "selectedStatusType");
  const B2B_API = createB2BAPI();
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [isScheduleFormOpen, setIsScheduleFormOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [originalDates, setOriginalDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  console.log(selectedDate, "selectedDataselectedDate");
  const [futureSelectedDate, setFutureSelectedDate] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [stockSchedule, setStockSchedule] = useState([]);
  const stockSchedules = purchaseOrder?.stockSchedules || [];
  const [reload, setReload] = useState(false)
  const allDates = useMemo(() => {
    return [...new Set(originalDates)].sort((a, b) =>
      moment(a, "DD/MM/YYYY").diff(moment(b, "DD/MM/YYYY"))
    );
  }, [originalDates, selectedDate]);
  const canSave = useMemo(() => {
    if (activeTabTop !== "ASN" || selectedStatusType !== "NEW") {
      return true;
    }

    if (!purchaseOrder?.items?.length) {
      return false;
    }

    return purchaseOrder.items.every((item) => {
      // For WHOLESALE orders, ensure all three ASN fields are present
      if (orderType === "WHOLESALE") {
        const asnRoll = Number(item.asnRoll) || 0;
        const asnQty = Number(item.asnQuantity) || 0;
        const coneWeight = Number(item.coneWeight) || 0;
        return asnRoll > 0 && asnQty > 0 && coneWeight > 0;
      }
      if (orderType === "SAMPLE") {
        const qty = Number(item.qty) || 0;
        return qty > 0;
      }
      return true;
    });
  }, [purchaseOrder?.items, activeTabTop, selectedStatusType, orderType]);
  // Add near other useEffects
  useEffect(() => {
    setPurchaseOrder(prev => {
      if (!prev?.items?.length) return prev;

      const clearedItems = prev.items.map(item => ({
        ...item,
        asnRoll: "",
        asnQuantity: "",
        coneWeight: "",
        totalConeWeight: 0,
        grossWeight: 0,
      }));

      return {
        ...prev,
        items: clearedItems
      };
    });
  }, [selectedDate]);
  useEffect(() => {
    const newInputValues = { ...inputValues };
    Object.keys(newInputValues).forEach((k) => {
      if (!k.endsWith(futureSelectedDate)) delete newInputValues[k];
    });
    setInputValues(newInputValues);
  }, [futureSelectedDate]);

  const handleCancelConfirm = async () => {
    setIsCancelModalOpen(false);
    try {
      await B2B_API.post(`purchase-order/rejectPoByVendor?poId=${purchaseOrder?.poId}`).json();
      notify({
        title: "Success",
        message: "Purchase Order rejected successfully",
        success: true
      });
      navigate('/Po-Wholesale');
    } catch (error) {
      console.error(error);
      let errMsg = "Failed to reject Purchase Order";
      try {
        const errData = await error.response.json();
        if (errData && errData.message) {
          errMsg = errData.message;
        }
      } catch (e) { }
      notify({
        title: "Error",
        message: error.message || errMsg,
        error: true
      });
    }
  };
  const getRollsForDate = (date, key) => {
    if (!date || !key || !Array.isArray(stockSchedules)) return 0;
    return stockSchedules.reduce((sum, s) => {
      const matchesSku =
        (s.variantSku && s.variantSku === key) ||
        (s.swatchId && s.swatchId === key);
      if (!matchesSku) return sum;

      const dDye = s.dyeLotDeliveryDate ? moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY") : null;
      const dFabric = s.fabricDeliveryDate ? moment(s.fabricDeliveryDate).format("DD/MM/YYYY") : null;
      const dGreige = s.greigeDeliveryDate ? moment(s.greigeDeliveryDate).format("DD/MM/YYYY") : null;
      const dNormal = s.deliveryDate ? moment(s.deliveryDate).format("DD/MM/YYYY") : null;
      const tempFab = s?.tempFab
      const tempDye = s?.tempDye
      const temp = s?.tempGreige

      const matches = [];
      if (dDye === date) matches.push("dye");
      if (dFabric === date) matches.push("fabric");
      if (dGreige === date) matches.push("greige");
      if (dNormal === date) matches.push("normal");
      if (tempFab === date) matches.push("tempFab")
      if (tempDye === date) matches.push("tempDye")
      if (temp === date) matches.push("tempGreige")

      let total = 0;

      if (dDye === date) total += (s.noOfDyeLotRolls || 0);
      if (dFabric === date) total += (s.noOfFabricRolls || 0);
      if (dGreige === date) total += (s.noOfGreigeRolls || 0);
      if (dNormal === date) total = s.qty || 0;
      if (tempDye === date) total += (s.noOfDyeLotRollsReduced || 0);
      if (tempFab === date) total += (s.noOfFabricRollsReduced || 0);
      if (temp === date) total += (s.noOfGreigeRollsReduced || 0);

      return sum + total;
    }, 0);
  };

  const getRollsForDateFilter = (date, key) => {
    if (!date || !key || !Array.isArray(stockSchedules)) return 0;

    return stockSchedules.reduce((sum, s) => {
      const matchesSku =
        (s.variantSku && s.variantSku === key) ||
        (s.swatchId && s.swatchId === key);
      if (!matchesSku) return sum;

      const dDye = s.dyeLotDeliveryDate ? moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY") : null;
      const dFabric = s.fabricDeliveryDate ? moment(s.fabricDeliveryDate).format("DD/MM/YYYY") : null;
      const dGreige = s.greigeDeliveryDate ? moment(s.greigeDeliveryDate).format("DD/MM/YYYY") : null;
      const dNormal = s.deliveryDate ? moment(s.deliveryDate).format("DD/MM/YYYY") : null;

      const matches = [];
      if (dDye === date) matches.push("dye");
      if (dFabric === date) matches.push("fabric");
      if (dGreige === date) matches.push("greige");
      if (dNormal === date) matches.push("normal");

      let total = 0;


      if (dDye === date) total += (s.noOfDyeLotRolls || 0);
      if (dFabric === date) total += (s.noOfFabricRolls || 0);
      if (dGreige === date) total += (s.noOfGreigeRolls || 0);
      if (dNormal === date) total = s.qty || 0;

      return sum + total;
    }, 0);
  };
  const handleRollChange = (id, inputValue) => {
    setPurchaseOrder((prev) => {
      const updatedItems = (prev.items || []).map((item) => {
        if (item.id !== id) return item;

        if (inputValue === "") {
          return { ...item, orderedRolls: "", qty: 0, totalAmount: 0 };
        }

        const orderedRolls = Math.max(0, parseFloat(inputValue) || 0);
        const stdKg = item.stdKg ?? 20;
        const qty = orderedRolls * stdKg;
        const totalAmount = qty * (item.costPrice || 0);

        return { ...item, orderedRolls, qty, totalAmount };
      });

      const newGrossTotal = updatedItems.reduce(
        (sum, item) => sum + (item.totalAmount || 0),
        0
      );

      return {
        ...prev,
        items: updatedItems,
        grossTotal: newGrossTotal,
      };
    });
  };
  const handleQtyChange = (id, inputValue) => {
    setPurchaseOrder((prev) => {
      const updatedItems = (prev.items || []).map((item) => {
        if (item.id !== id) return item;

        if (inputValue === "") {
          return { ...item, orderedRolls: 0, qty: "", totalAmount: 0 };
        }

        const qty = Math.max(0, parseFloat(inputValue) || 0);
        const stdKg = item.stdKg ?? 20;
        const orderedRolls = stdKg > 0 ? parseFloat((qty / stdKg).toFixed(2)) : 0;
        const totalAmount = qty * (item.costPrice || 0);

        return { ...item, orderedRolls, qty, totalAmount };
      });

      const newGrossTotal = updatedItems.reduce(
        (sum, item) => sum + (item.totalAmount || 0),
        0
      );

      return {
        ...prev,
        items: updatedItems,
        grossTotal: newGrossTotal,
      };
    });
  };
  const handleStdKgChange = (id, inputValue) => {
    setPurchaseOrder((prev) => {
      const updatedItems = (prev.items || []).map((item) => {
        if (item.id !== id) return item;

        const orderedRolls = Number(item.orderedRolls) || 0;

        // IMPORTANT: don't force number here
        const stdKg = inputValue;

        return {
          ...item,
          stdKg, // keep raw string
          qty:
            inputValue === "" || isNaN(Number(inputValue))
              ? 0
              : parseFloat((orderedRolls * Number(inputValue)).toFixed(2)),
          totalAmount:
            inputValue === "" || isNaN(Number(inputValue))
              ? 0
              : parseFloat(
                (orderedRolls * Number(inputValue) * (item.costPrice || 0)).toFixed(2)
              ),
        };
      });

      const newGrossTotal = updatedItems.reduce(
        (sum, item) => sum + (item.totalAmount || 0),
        0
      );

      return {
        ...prev,
        items: updatedItems,
        grossTotal: newGrossTotal,
      };
    });
  };
  const handleSaveUnApprovedPo = async () => {
    try {
      const payload = {
        poId: purchaseOrder.poId,
        items: (purchaseOrder.items || []).map((item) => ({
          id: item.id,
          orderedRolls: item.orderedRolls || 0,
          qty: item.qty || 0,
          stdKg: item.stdKg === "" ? null : Number(item.stdKg),
        })),
      };

      await B2B_API.post("purchase-order/unApproved/update", { json: payload }).json();
      notify({ error: false, success: true, message: "Purchase Order updated successfully" });
      navigate("/Po-Wholesale", {
        state: { activeHeaderBack: activeTabTop, selectedStatusTypeFromBack: selectedStatusType },
      });
    } catch (error) {
      console.error("Save error:", error);
      notify({ error: true, message: `Failed to save purchase order: ${error.message}` });
    }
  };

  const handleSaveProduct = async () => {
    try {
      if (!selectedDate) {
        notify({ error: true, message: "Please select a delivery date before saving" });
        return;
      }

      const cleanOrder = JSON.parse(JSON.stringify(purchaseOrder));

      cleanOrder.stockSchedules = cleanOrder.stockSchedules
        ?.filter((s, index) => {
          const dDye = s.dyeLotDeliveryDate
            ? moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY")
            : null;
          const dFabric = s.fabricDeliveryDate
            ? moment(s.fabricDeliveryDate).format("DD/MM/YYYY")
            : null;
          const dGreige = s.greigeDeliveryDate
            ? moment(s.greigeDeliveryDate).isValid()
              ? moment(s.greigeDeliveryDate).format("DD/MM/YYYY")
              : null
            : null;
          const dNormal = s.deliveryDate
            ? moment(s.deliveryDate).format("DD/MM/YYYY")
            : null;
          const tempFab = s?.tempFab
          const tempDye = s?.tempDye
          const temp = s?.tempGreige

          if (orderType === "WHOLESALE") {
            if (dDye === selectedDate && s.noOfDyeLotRolls > (0)) {
              return true;
            }
            if (dFabric === selectedDate && s.noOfFabricRolls > (0)) {
              return true;
            }
            if (dGreige === selectedDate && s.noOfGreigeRolls > (0)) {
              return true;
            }
            if (temp === selectedDate || tempFab === selectedDate || tempDye === selectedDate) {
              return true
            }
            return false;
          }

          return dNormal === selectedDate && s.qty > (s.noOfRollOrdered || 0) && !s.deliveryCreated;
        })
        .map((s) => {
          const dDye = s.dyeLotDeliveryDate ? moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY") : null;
          const dFabric = s.fabricDeliveryDate ? moment(s.fabricDeliveryDate).format("DD/MM/YYYY") : null;
          const dGreige = s.greigeDeliveryDate
            ? moment(s.greigeDeliveryDate).isValid()
              ? moment(s.greigeDeliveryDate).format("DD/MM/YYYY")
              : null
            : null;
          const dNormal = s.deliveryDate ? moment(s.deliveryDate).format("DD/MM/YYYY") : null;

          let newDyeLotCreated = s.dyeLotCreated;
          let newFabricCreated = s.fabricCreated;
          let newGreigeCreated = s.greigeCreated;
          let fabricReduce = 0
          let dyeReduce = 0
          let griegeRedued = 0

          if (orderType === "WHOLESALE") {
            if (dDye === selectedDate && s.noOfDyeLotRolls > 0) {
              dyeReduce = s.noOfDyeLotRolls
            }
            if (dFabric === selectedDate && s.noOfFabricRolls > 0) {
              fabricReduce = s.noOfFabricRolls;
            }
            if (dGreige === selectedDate && s.noOfGreigeRolls > 0) {
              griegeRedued = s.noOfGreigeRolls;
            }

            return {
              ...s,
              dyeLotCreated: newDyeLotCreated,
              fabricCreated: newFabricCreated,
              greigeCreated: newGreigeCreated,
              noOfFabricRollsReduced: (s.noOfFabricRollsReduced || 0) + fabricReduce,
              noOfDyeLotRollsReduced: (s.noOfDyeLotRollsReduced || 0) + dyeReduce,
              noOfGreigeRollsReduced: (s.noOfGreigeRollsReduced || 0) + griegeRedued
            };
          } else {
            if (dNormal === selectedDate && s.qty > (s.noOfRollOrdered || 0)) {
              return {
                ...s,
                deliveryCreated: true,
              };
            }
            return s;
          }
        });


      cleanOrder.items = purchaseOrder.items.map((item) => ({
        ...item,
        vendorStdKg: item.vendorStdKg,
      }));

      const response = await B2B_API.post("asn/createAsn", { json: cleanOrder }).json();
      setPurchaseOrder(response.response);
      notify({ error: false, success: true, message: `Product saved successfully` });
      navigate("/Po-Wholesale");
    } catch (error) {
      console.error("Save error:", error);
      notify({ error: true, message: `Failed to save product: ${error.message}` });
    }
  };
  const getKeyForItem = (item) =>
    orderType === "SWATCH" ? item.swatchId || purchaseOrder?.swatchId : item.variantSku;

  const filteredItems = useMemo(() => {
    return (purchaseOrder?.items || [])
      .map((item) => {
        const key = getKeyForItem(item);
        const hasvariantsku = Boolean(item?.variantSku);
        const hasswatchId = Boolean(item?.swatchId);
        if (!key) return null;
        let matchingSchedule = null;
        if (orderType !== "WHOLESALE") {
          matchingSchedule = (stockSchedules || []).find(
            (s) =>
              ((hasswatchId && s?.swatchId === item?.swatchId) ||
                (hasvariantsku && s?.variantSku === item?.variantSku)) &&
              s?.deliveryDate &&
              moment(s.deliveryDate).format("DD/MM/YYYY") === selectedDate &&
              !s.deliveryCreated &&
              (s.qty || 0) > 0
          );
          if (!matchingSchedule) return null;
        } else {
          if (getRollsForDate(selectedDate, key) <= 0) return null;

          matchingSchedule = (stockSchedules || []).filter(
            (s) =>
              (s?.variantSku === item?.variantSku || s?.swatchId === item?.swatchId) &&
              (
                (s.dyeLotDeliveryDate &&
                  moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY") === selectedDate &&
                  s.noOfDyeLotRolls > 0 &&
                  !s.dyeLotCreated) ||
                (s.fabricDeliveryDate &&
                  moment(s.fabricDeliveryDate).format("DD/MM/YYYY") === selectedDate &&
                  s.noOfFabricRolls > 0 &&
                  !s.fabricCreated) ||
                (s.greigeDeliveryDate &&
                  moment(s.greigeDeliveryDate).format("DD/MM/YYYY") === selectedDate &&
                  s.noOfGreigeRolls > 0 &&
                  !s.greigeCreated) || (
                  s.deliveryDate &&
                  moment(s.deliveryDate).format("DD/MM/YYYY") === selectedDate &&
                  s.qty > 0 &&
                  !s.deliveryCreated
                ) || (s?.tempDye && s?.tempDye === selectedDate) || (s?.tempFab === selectedDate) || (s.tempGreige === selectedDate)
              )
          );
          matchingSchedule
          if (!matchingSchedule) return null;
        }
        return { ...item, stockSchedule: matchingSchedule };
      })
      .filter(Boolean);
  }, [purchaseOrder, selectedDate, orderType]);

  const futurefilteredItems = useMemo(() => {
    return (purchaseOrder?.items || [])
      .map((item) => {
        const key = getKeyForItem(item);
        const hasvariantsku = Boolean(item?.variantSku);
        const hasswatchId = Boolean(item?.swatchId);
        if (!key) return null;

        let matchingSchedule = null;

        if (orderType === "SWATCH" || orderType === "SAMPLE") {
          matchingSchedule = (purchaseOrder?.stockSchedules || []).find(
            (s) =>
              ((hasswatchId && s?.swatchId === item?.swatchId) ||
                (hasvariantsku && s?.variantSku === item?.variantSku)) &&
              (
                (s.dyeLotDeliveryDate && moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY") === futureSelectedDate && s.noOfDyeLotRolls > 0 && !s.dyeLotCreated) ||
                (s.fabricDeliveryDate && moment(s.fabricDeliveryDate).format("DD/MM/YYYY") === futureSelectedDate && s.noOfFabricRolls > 0 && !s.fabricCreated) ||
                (s.greigeDeliveryDate && moment(s.greigeDeliveryDate).format("DD/MM/YYYY") === futureSelectedDate && s.noOfGreigeRolls > 0 && !s.greigeCreated) ||
                (s.deliveryDate && moment(s.deliveryDate).format("DD/MM/YYYY") === futureSelectedDate && s.qty > 0 && !s.deliveryCreated)
              ) &&
              (s.qty || 0) > (s.noOfRollOrdered || 0)
          );

          if (!matchingSchedule) return null;
        } else {
          if (getRollsForDate(futureSelectedDate, key) <= 0) return null;

          matchingSchedule = (purchaseOrder?.stockSchedules || []).find(
            (s) =>
              ((hasswatchId && s?.swatchId === item?.swatchId) ||
                (hasvariantsku && s?.variantSku === item?.variantSku)) &&
              (
                (s.dyeLotDeliveryDate &&
                  moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY") === futureSelectedDate &&
                  s.noOfDyeLotRolls > 0 &&
                  !s.dyeLotCreated &&
                  (s.noOfDyeLotRolls || 0) > 0) ||
                (s.fabricDeliveryDate &&
                  moment(s.fabricDeliveryDate).format("DD/MM/YYYY") === futureSelectedDate &&
                  s.noOfFabricRolls > 0 &&
                  !s.fabricCreated &&
                  (s.noOfFabricRolls || 0) > 0) ||
                (s.greigeDeliveryDate &&
                  moment(s.greigeDeliveryDate).format("DD/MM/YYYY") === futureSelectedDate &&
                  s.noOfGreigeRolls > 0 &&
                  !s.greigeCreated &&
                  (s.noOfGreigeRolls || 0) > 0)
              )
          );

          if (!matchingSchedule) return null;
        }

        return { ...item, stockSchedule: matchingSchedule };
      })
      .filter(Boolean);
  }, [purchaseOrder, futureSelectedDate, orderType]);



  const handleSelectedDateChange = (date) => {
    setSelectedDate(date);
    setPurchaseOrder((prev) => ({
      ...prev,
      stockSchedules: stockSchedule
    }))
    setFutureSelectedDate(null);
  };

  const fetchPurchaseOrder = async () => {
    try {
      const response =
        activeTabTop === "ASN" && selectedStatusType !== "NEW"
          ? await B2B_API.get(`asn/getAsnById?asnNo=${asnId}`).json()
          : activeTabTop === "GE"
            ? await B2B_API.get(`asn/getAsnById?asnNo=${asnId}`).json()
            : activeTabTop === "GRN"
              ? await B2B_API.get(`asn/getAsnById?asnNo=${asnId}`).json()
              : selectedStatusType === "PENDING"
                ? await B2B_API.get(`purchase-order/getUnApprovedPoById?poId=${poId}`).json()
                : selectedStatusType === "REJECTED"
                  ? await B2B_API.get(`purchase-order/getPoOrUnApprovedPoById?poId=${poId}`).json()
                  : await B2B_API.get(`purchase-order/getPoById?poId=${poId}`).json();

      const poData = response.response;
      const allDates = [];
      let updateSedulte = []
      setStockSchedule(poData?.stockSchedules);

      const isMultiLrView = poData?.multiLrNo && (
        (activeTabTop === "ASN" && selectedStatusType === "CONFIRMED") ||
        activeTabTop === "GE" ||
        activeTabTop === "GRN"
      );

      if (isMultiLrView) {
        const groupRes = await B2B_API.get(`asn/getAsnGroup?multiLrNo=${poData.multiLrNo}`).json();
        const groupAsns = groupRes.response;

        const allAsnNos = [...new Set(groupAsns.map(a => a.asnNo))];
        const allPoIds = groupAsns.map(a => a.poId);

        poData.groupedAsnNos = allAsnNos.join(", ");
        poData.groupedPoIds = allPoIds.join(", ");

        const colors = ['red', 'blue', '#43A047', '#8E24AA', '#F4511E'];
        const asnColors = {};
        allAsnNos.forEach((asn, idx) => {
          asnColors[asn] = colors[idx % colors.length];
        });

        const mergedItemsMap = {};
        groupAsns.forEach(asn => {
          (asn.items || []).forEach(item => {
            const key = item.variantSku || item.swatchId || item.id;
            if (!mergedItemsMap[key]) {
              mergedItemsMap[key] = { ...item, sourceAsns: [asn.asnNo] };
            } else {
              const existing = mergedItemsMap[key];
              existing.qty = (existing.qty || 0) + (item.qty || 0);
              existing.asnRoll = (existing.asnRoll || 0) + (item.asnRoll || 0);
              existing.asnQuantity = (existing.asnQuantity || 0) + (item.asnQuantity || 0);
              existing.orderedRolls = (existing.orderedRolls || 0) + (item.orderedRolls || 0);
              existing.totalAmount = (existing.totalAmount || 0) + (item.totalAmount || 0);
              if (existing.uom !== item.uom && item.uom) {
                if (!existing.uom?.includes(item.uom)) {
                  existing.uom = (existing.uom || "") + ", " + item.uom;
                }
              }
              if (!existing.sourceAsns.includes(asn.asnNo)) {
                existing.sourceAsns.push(asn.asnNo);
              }
            }
          });
        });

        poData.items = Object.values(mergedItemsMap);
        poData.asnColors = asnColors;
        poData.grossTotal = groupAsns.reduce((sum, asn) => sum + (asn.grossTotal || 0), 0);
      }

      if (orderType === "WHOLESALE") {
        updateSedulte = poData?.stockSchedules?.map((s) => {
          return {
            ...s,
            noOfFabricRolls: (s?.noOfFabricRolls || 0) - (s.fabricCreated ? (s?.noOfFabricRolls || 0) : (s?.noOfFabricRollsReduced || 0)),
            noOfFabricRollsReduced: 0,
            noOfDyeLotRolls: (s?.noOfDyeLotRolls || 0) - (s.dyeLotCreated ? (s?.noOfDyeLotRolls || 0) : (s?.noOfDyeLotRollsReduced || 0)),
            noOfDyeLotRollsReduced: 0,
            noOfGreigeRolls: (s?.noOfGreigeRolls || 0) - (s.greigeCreated ? (s?.noOfGreigeRolls || 0) : (s?.noOfGreigeRollsReduced || 0)),
            noOfGreigeRollsReduced: 0,
            fabDateInMoment: s?.fabricDeliveryDate ? moment(s.fabricDeliveryDate).format("DD/MM/YYYY") : null,
            greigeDateInMoment: s?.greigeDeliveryDate ? moment(s.greigeDeliveryDate).format("DD/MM/YYYY") : null,
            dyeDateInMoment: s?.dyeLotDeliveryDate ? moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY") : null

          }
        })

        setStockSchedule(updateSedulte);
        updateSedulte?.forEach((s) => {
          if (s.dyeLotDeliveryDate && (s.noOfDyeLotRolls || 0) > 0 && !s.dyeLotCreated) {
            allDates.push(moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY"));
          }
          if (s.fabricDeliveryDate && (s.noOfFabricRolls || 0) > 0 && !s.fabricCreated) {
            allDates.push(moment(s.fabricDeliveryDate).format("DD/MM/YYYY"));
          }
          if (s.greigeDeliveryDate && (s.noOfGreigeRolls || 0) > 0 && !s.greigeCreated) {
            allDates.push(moment(s.greigeDeliveryDate).format("DD/MM/YYYY"));
          }
        });
      } else {
        poData?.stockSchedules?.map((s) => {
          if (s?.deliveryDate && (s.qty || 0) > 0 && !s.deliveryCreated) {
            allDates.push(moment(s.deliveryDate).format("DD/MM/YYYY"));
          }
        });
        updateSedulte = poData?.stockSchedules
        setStockSchedule(poData?.stockSchedules);
      }
      setPurchaseOrder({ ...poData, stockSchedules: updateSedulte });
      const sortedDates = [...new Set(allDates)].sort((a, b) =>
        moment(a, "DD/MM/YYYY").diff(moment(b, "DD/MM/YYYY"))
      );
      setOriginalDates(sortedDates);
    } catch (error) {
      notify({
        title: 'Error!', error: true,
        success: false,
        message: error?.message || 'Failed to fetch purchase order details',
      });
    }
  }

  useEffect(() => {
    if (poId) fetchPurchaseOrder();
  }, [poId, location]);
  const renderGroupedValue = (groupedValue, singleValue, label) => {
    const list = groupedValue
      ? groupedValue.split(',').map(item => item.trim())
      : singleValue
        ? [singleValue]
        : [];

    if (list.length <= 1) {
      return list[0] || "-";
    }

    return (
      <Popover width={250} position="bottom" withArrow shadow="md">
        <Popover.Target>
          <span
            style={{
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            {list.length} {label}s
          </span>
        </Popover.Target>

        <Popover.Dropdown p={6} style={{ width: 'fit-content' }}>
          <div
            style={{
              fontSize: 12,
              fontWeight: 600,
              whiteSpace: 'nowrap'
            }}
          >
            {list.join(', ')}
          </div>
        </Popover.Dropdown>
      </Popover>
    );
  };
  const fields = useMemo(
    () => [
      {
        label: "Purchase Order No",
        value: renderGroupedValue(
          purchaseOrder?.groupedPoIds,
          purchaseOrder?.poId,
          "PO"
        )
      },

      (activeTabTop === "ASN" && selectedStatusType !== "NEW") ||
        activeTabTop === "GE" ||
        activeTabTop === "GRN"
        ? {
          label: "ASN No",
          value: renderGroupedValue(
            purchaseOrder?.groupedAsnNos,
            purchaseOrder?.asnNo,
            "ASN"
          )
        }
        : null,

      (activeTabTop === "GE" && selectedStatusType === "CONFIRMED") ||
        activeTabTop === "GRN"
        ? {
          label: "GE No",
          value: purchaseOrder?.ge?.geNo || "-"
        }
        : null,

      activeTabTop === "GRN" && selectedStatusType === "CONFIRMED"
        ? {
          label: "GRN No",
          value: purchaseOrder?.grnNo || "-"
        }
        : null,

      {
        label: "Created Date",
        value: purchaseOrder?.createdDate
          ? moment(purchaseOrder.createdDate).format("DD/MM/YYYY")
          : "-"
      },

      {
        label: "Created By",
        value: purchaseOrder?.vendor?.buyerName || "-"
      }
    ].filter(Boolean),
    [purchaseOrder, activeTabTop, selectedStatusType]
  );
  const handleAsnChange = (rowItem, field, value) => {
    setPurchaseOrder((prev) => ({
      ...prev,
      items: prev.items.map((item) =>
        item.id === rowItem.id
          ? {
            ...item,
            [field]: value === "" ? "" : Number(value),
          }
          : item
      ),
    }));
  };

  const getItemColor = (item) => {
    if (purchaseOrder?.asnColors && item?.sourceAsns?.length === 1) {
      return purchaseOrder.asnColors[item.sourceAsns[0]];
    }
    return 'inherit';
  };

  const productColumns = useMemo(() => [
    {
      header: "Product Name",
      accessorKey: "productName",
      Cell: ({ row }) => row.original?.productName || "N/A",
      size: 300,
      mantineTableHeadCellProps: { align: "center" },
      mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
    },
    {
      header: "Vendor Product Name",
      accessorKey: "productVariant",
      Cell: ({ row }) => row.original?.productVariant?.vendorProductName || row.original?.vendorProductName || "N/A",
      size: 200,
      mantineTableHeadCellProps: { align: "center" },
      mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
    },
    {
      header: "UOM",
      accessorKey: "uom",
      size: 100,
      mantineTableHeadCellProps: { align: "center" },
      mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
    },
    ...(purchaseOrder?.orderType !== "WHOLESALE"
      ? []
      : [
        {
          header: activeTabTop === "ASN" ? "PO Rolls" : "PO Rolls",
          accessorKey: "calculatedRolls",
          size: 100,
          mantineTableHeadCellProps: { align: "center" },
          mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
          Cell: ({ row }) => {
            const item = row.original;
            if (selectedStatusType === "PENDING") {
              return <span>{item?.orderedRolls ?? "-"}</span>;
            }
            const key = orderType === "SWATCH" ? item.swatchId || purchaseOrder?.swatchId : item.variantSku;
            const rolls = getRollsForDate(selectedDate, key);
            return <span>{activeTabTop === "ASN" && selectedStatusType !== "PENDING" && selectedStatusType !== "CONFIRMED" ? rolls : item?.orderedRolls}</span>;
          },
        },
        // {
        //   header: "Std Kg / Roll",
        //   accessorKey: "stdKg",
        //   size: 120,
        //   mantineTableHeadCellProps: { align: "center" },
        //   mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
        //   Cell: ({ row }) => {
        //     const item = row.original;
        //     if (selectedStatusType === "PENDING") {
        //       return (
        //         <Input
        //           type="number"
        //           size="xs"
        //           value={item?.stdKg ?? ""}
        //           min={1}
        //           onChange={(e) => handleStdKgChange(item.id, e.target.value)}
        //           onBlur={(e) => {
        //             if (!e.target.value || Number(e.target.value) < 1) {
        //               handleStdKgChange(item.id, "1");
        //             }
        //           }}
        //           style={{ width: "90px" }}
        //         />
        //       );
        //     }
        //     return <span>{item?.stdKg ?? "-"}</span>;
        //   },
        // },
      ]),
    {
      header: activeTabTop === "ASN" ? "PO Qty" : "PO Qty",
      accessorKey: "orderedQty",
      size: 100,
      mantineTableHeadCellProps: { align: "center" },
      mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
      Cell: ({ row }) => {
        const item = row.original;
        if (selectedStatusType === "PENDING") {
          return <span>{item?.qty ?? "-"}</span>;
        }
        if (orderType === "WHOLESALE" && activeTabTop === "ASN" && selectedStatusType !== "PENDING" && selectedStatusType !== "CONFIRMED") {
          const key = orderType === "SWATCH" ? item.swatchId || purchaseOrder?.swatchId : item.variantSku;
          const rolls = getRollsForDate(selectedDate, key);
          return rolls * item?.stdKg;
        }
        if (orderType === "SAMPLE") {
          return item?.qty ?? "-";
        }
        return item?.orderedRolls * item?.stdKg;
      },
    },

    ...(orderType === "WHOLESALE" && activeTabTop !== "PO"
      ? [
        {
          header: (
            <span style={{ display: "flex", flexDirection: "row" }}>
              ASN Roll <span style={{ color: "red" }}>*</span>
            </span>
          ),
          mobileLabel: "ASN Roll",
          accessorKey: "asnRoll",
          size: 150,
          require: true,
          mantineTableHeadCellProps: { align: "center" },
          mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
          Cell: ({ row }) => {
            const value = row.original.asnRoll;

            if (selectedStatusType !== "NEW") {
              return <span>{value}</span>;
            }

            return (
              <Input
                type="number"
                required={true}
                placeholder="Enter Roll"
                value={value ?? ""}
                style={{ width: "80px" }}
                onChange={(e) =>
                  handleAsnChange(row.original, "asnRoll", e.target.value)
                }
              />
            );
          },
        }] : []),

    ...(activeTabTop !== "PO"
      ? [
        {
          header: (
            <span>
              ASN Qty <span style={{ color: "red" }}>*</span>
            </span>
          ),
          mobileLabel: "ASN Qty",
          accessorKey: 'asnQuantity',
          size: 100,
          mantineTableHeadCellProps: { align: 'center' },
          mantineTableBodyCellProps: ({ row }) => ({ align: 'center', style: { color: getItemColor(row.original) } }),
          Cell: ({ row }) => {
            const value = row.original.asnQuantity;

            if (selectedStatusType !== "NEW") {
              return <span>{value}</span>;
            }

            return (
              <Input
                type="number"
                placeholder="Enter Qty"
                value={value ?? ""}
                onChange={(e) =>
                  handleAsnChange(row.original, "asnQuantity", e.target.value)
                }
              />
            );
          },
        }] : []),
    ...(orderType === "WHOLESALE" && activeTabTop !== "PO"
      ? [
        {
          header: (
            <span>
              Cone Weight (Gms) <span style={{ color: "red" }}>*</span>
            </span>
          ),
          mobileLabel: "Cone Weight",
          accessorKey: 'coneWeight (Gms)',
          size: 100,
          mantineTableHeadCellProps: { align: 'center' },
          mantineTableBodyCellProps: ({ row }) => ({ align: 'center', style: { color: getItemColor(row.original) } }),
          Cell: ({ row }) => {
            const sku = row.original?.variantSku;

            const currentItem = purchaseOrder?.items?.find(
              (item) => item.variantSku === sku
            );

            const value = currentItem?.coneWeight;

            if (selectedStatusType !== "NEW") {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent:"center",
                    flexDirection:"column"
                  }}
                >
                  <span>{value}</span>

                  {value > 0 && (
                    <span
                      style={{
                        color: "red",
                        fontSize: "12px",
                        fontWeight: 600,
                        marginLeft:"5px"
                      }}
                    >
                      {(value / 1000).toFixed(2)} kg
                    </span>
                  )}
                </div>
              );
            }

            const asnQty = Number(currentItem?.asnQuantity) || 0;

            const handleChange = (val) => {
              setPurchaseOrder((prev) => {
                const updatedItems = prev.items.map((item) =>
                  item.variantSku === sku
                    ? {
                      ...item,
                      coneWeight: val,
                      grossWeight:
                        (asnQty + currentItem?.asnRoll * val) || 0,
                      totalConeWeight:
                        ((currentItem?.asnRoll || 0) * (val || 0)) || 0,
                    }
                    : item
                );
                return { ...prev, items: updatedItems };
              });
            };

            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Input
                  type="number"
                  value={value ?? ""}
                  min={0}
                  placeholder="Enter Cone Weight"
                  step="0.01"
                  onChange={(e) => handleChange(Number(e.target.value))}
                  style={{ width: "80px" }}
                />
                {value > 0 && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "12px",
                      fontWeight: 600,
                      marginLeft: "4px",
                    }}
                  >
                    {(value / 1000).toFixed(2)} kg
                  </span>
                )}
              </div>
            );
          },
        }] : []),
    ...(orderType === "WHOLESALE" && activeTabTop !== "PO"
      ? [
        {
          header: "Total Cone Weight",
          accessorKey: "totalConeWeight",
          size: 120,
          mantineTableHeadCellProps: { align: "center" },
          mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
          Cell: ({ row }) => {
            console.log(row?.original, "original")
            const sku = row.original?.variantSku;
            const currentItem = purchaseOrder?.items?.find((item) => item.variantSku === sku);
            return <span>{(currentItem?.asnRoll || 0) * (currentItem?.coneWeight || 0)}</span>
          },
        }] : []),
    ...(orderType === "WHOLESALE"
      ? [
        {
          header: 'Gross Qty',
          accessorKey: 'grossWeight',
          size: 100,
          mantineTableHeadCellProps: { align: 'center' },
          mantineTableBodyCellProps: ({ row }) => ({ align: 'center', style: { color: getItemColor(row.original) } }),
          Cell: ({ row }) => {
            const sku = row.original?.variantSku;

            const currentItem = purchaseOrder?.items?.find(
              (item) => item.variantSku === sku
            );

            const gross = currentItem?.grossWeight;
            const calcValue =
              (Number(currentItem?.asnQuantity) || 0) +
              (Number(currentItem?.totalConeWeight) || 0);

            if (selectedStatusType !== "NEW") {
              return <span>{gross}</span>;
            }

            return <span>{calcValue}</span>;
          },
        }] : []),

    ...(orderType === "WHOLESALE"
      ? [
        {
          header: "Cost Price / Qty",
          accessorKey: "costPrice",
          size: 100,
          mantineTableHeadCellProps: { align: "center" },
          mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
          Cell: ({ row }) => `₹ ${row.original?.stockSchedule?.costPrice ? row.original?.stockSchedule?.costPrice.toFixed(2) : row.original?.costPrice?.toFixed(2)}`,
        },
        {
          header: "Product Total Amt",
          accessorKey: "total",
          size: 100,
          mantineTableHeadCellProps: { align: "center" },
          mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
          Cell: ({ row }) => `₹ ${row.original?.totalAmount?.toFixed(2)}`,
        }] : []),

  ], [purchaseOrder, selectedDate, orderType, activeTabTop, selectedStatusType, handleRollChange, handleQtyChange]);

  const futureProductColumns = useMemo(() => [
    {
      header: "Product Name",
      accessorKey: "productName",
      Cell: ({ row }) => row.original?.productName || "N/A",
      size: 200,
      mantineTableHeadCellProps: { align: "center" },
      mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
    },
    {
      header: "Vendor Product Name",
      accessorKey: "productVariant",
      Cell: ({ row }) => row.original?.productVariant?.vendorProductName || row.original?.vendorProductName || "N/A",
      size: 200,
      mantineTableHeadCellProps: { align: "center" },
      mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
    },
    {
      header: "UOM",
      accessorKey: "uom",
      size: 100,
      mantineTableHeadCellProps: { align: "center" },
      mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
    },
    ...(purchaseOrder?.orderType !== "WHOLESALE"
      ? []
      : [
        {
          header: "No of Rolls",
          accessorKey: "calculatedRolls",
          size: 100,
          mantineTableHeadCellProps: { align: "center" },
          mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
          Cell: ({ row }) => {
            const item = row.original;
            const key = orderType === "SWATCH" ? item.swatchId || purchaseOrder?.swatchId : item.variantSku;
            const rolls = getRollsForDateFilter(futureSelectedDate, key);
            return <span>{activeTabTop === "ASN" && selectedStatusType !== "CONFIRMED" && selectedStatusType !== "PENDING" ? rolls : item?.orderedRolls}</span>;
          },
        },
      ]),
    {
      header: "Ordered Qty",
      accessorKey: "qty",
      size: 100,
      mantineTableHeadCellProps: { align: "center" },
      mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
      Cell: ({ row }) => {
        const item = row.original;
        if (orderType === "WHOLESALE") {
          const key = orderType === "SWATCH" ? item.swatchId || purchaseOrder?.swatchId : item.variantSku;
          const rolls = getRollsForDate(futureSelectedDate, key);
          return rolls * item?.stdKg;
        } else {
          return item?.qty;
        }
      },
    },
    // {
    //   header: "Cost Price / Qty",
    //   accessorKey: "costPrice",
    //   size: 100,
    //   mantineTableHeadCellProps: { align: "center" },
    //   mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
    //   Cell: ({ row }) => `₹ ${row.original?.stockSchedule?.costPrice ? row.original?.stockSchedule?.costPrice.toFixed(2) : row.original?.costPrice?.toFixed(2)}`,
    // },
    // {
    //   header: "Product Total",
    //   accessorKey: "total",
    //   size: 100,
    //   mantineTableHeadCellProps: { align: "center" },
    //   mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
    //   Cell: ({ row }) => `₹ ${row.original?.totalAmount?.toFixed(2)}`,
    // },
    {
      header: "Rolls to add ",
      accessorKey: "calculatedRolls",
      size: 100,
      mantineTableHeadCellProps: { align: "center" },
      mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
      Cell: ({ row }) => {
        const item = row.original;
        const key = orderType === "SWATCH" ? item.swatchId || purchaseOrder?.swatchId : item.variantSku;
        const rolls = getRollsForDate(futureSelectedDate, key);
        const inputKey = `${key}_${futureSelectedDate}`;
        const currentValue = inputValues[inputKey] ?? rolls;
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <NumberInput
              style={{ width: "80px" }}
              min={0}
              max={rolls}
              value={currentValue}
              onChange={(val) => {
                const normalized = typeof val === "number" && !isNaN(val)
                  ? Math.min(val, rolls)
                  : 0;
                setInputValues((prev) => ({ ...prev, [inputKey]: normalized }));
                setPurchaseOrder((prev) => {
                  const schedules = (prev.stockSchedules || []).map((s) => {
                    const matchesKey = orderType === "SWATCH" ? s.swatchId === key : s.variantSku === key;
                    if (!matchesKey) return s;

                    const dateMatch =
                      (s.greigeDeliveryDate && moment(s.greigeDeliveryDate).format("DD/MM/YYYY") === futureSelectedDate) ||
                      (s.fabricDeliveryDate && moment(s.fabricDeliveryDate).format("DD/MM/YYYY") === futureSelectedDate) ||
                      (s.dyeLotDeliveryDate && moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY") === futureSelectedDate);

                    if (dateMatch) {
                      return { ...s, tempReduced: normalized };
                    }
                    return s;
                  });
                  return { ...prev, stockSchedules: schedules };
                });
              }}
            />
          </div>
        );
      }
    },
    {
      header: "Add to Stock",
      accessorKey: "addToStock",
      size: 140,
      mantineTableHeadCellProps: { align: "center" },
      mantineTableBodyCellProps: ({ row }) => ({ align: "center", style: { color: getItemColor(row.original) } }),
      Cell: ({ row }) => {
        const sku = row.original?.variantSku || row.original?.swatchId;
        const key = orderType === "SWATCH" ? row.original?.swatchId || purchaseOrder?.swatchId : row.original?.variantSku;
        const rolls = getRollsForDate(futureSelectedDate, key);
        const inputKey = `${key}_${futureSelectedDate}`;
        const currentValue = inputValues[inputKey] ?? rolls;
        const handleAddToStock = (sku, item) => {
          setPurchaseOrder((prev) => {
            if (!selectedDate || !futureSelectedDate) return prev;
            let schedules = [...(prev.stockSchedules || [])];
            if (orderType === "WHOLESALE") {
              const futureSchedules = schedules.filter((s) => {
                if (s.variantSku !== sku) return false;
                const dDye = s.dyeLotDeliveryDate ? moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY") : null;
                const dFabric = s.fabricDeliveryDate ? moment(s.fabricDeliveryDate).format("DD/MM/YYYY") : null;
                const dGreige = s.greigeDeliveryDate ? moment(s.greigeDeliveryDate).format("DD/MM/YYYY") : null;
                return dDye === futureSelectedDate || dFabric === futureSelectedDate || dGreige === futureSelectedDate;
              });

              if (futureSchedules.length === 0) return prev;

              const updated = schedules.map((fs) => {
                if (fs.variantSku !== sku) return fs;
                const dDye = fs.dyeLotDeliveryDate ? moment(fs.dyeLotDeliveryDate).format("DD/MM/YYYY") : null;
                const dFabric = fs.fabricDeliveryDate ? moment(fs.fabricDeliveryDate).format("DD/MM/YYYY") : null;
                const dGreige = fs.greigeDeliveryDate ? moment(fs.greigeDeliveryDate).format("DD/MM/YYYY") : null;
                let tempFab = false;
                let tempDye = false;
                let tempGreige = false;
                let moveGreige = fs?.tempReduced || rolls || 0
                let updatedFuture = { ...fs };
                if (
                  moveGreige > 0 &&
                  fs.greigeDeliveryDate &&
                  dGreige === futureSelectedDate
                ) {
                  const toReduce = Math.min(moveGreige, (fs.noOfGreigeRolls))
                  updatedFuture.noOfGreigeRollsReduced = (fs.noOfGreigeRollsReduced || 0) + toReduce;
                  updatedFuture.noOfGreigeRolls = (fs?.noOfGreigeRolls - toReduce)
                  updatedFuture.tempReduced = 0;
                  moveGreige = moveGreige - toReduce
                  updatedFuture.tempGreige = selectedDate
                  tempGreige = true;
                }

                if (
                  moveGreige > 0 &&
                  fs.fabricDeliveryDate &&
                  dFabric === futureSelectedDate
                ) {
                  const toReduce = Math.min(moveGreige, (fs.noOfFabricRolls))
                  updatedFuture.noOfFabricRollsReduced = (fs.noOfFabricRollsReduced || 0) + toReduce;
                  updatedFuture.tempReduced = 0;
                  updatedFuture.tempFab = selectedDate
                  moveGreige = moveGreige - toReduce
                  tempFab = true
                  updatedFuture.noOfFabricRolls = (fs?.noOfFabricRolls - toReduce)

                }

                if (
                  moveGreige > 0 &&
                  fs.dyeLotDeliveryDate &&
                  dDye === futureSelectedDate
                ) {
                  const toReduce = Math.min(moveGreige, (fs.noOfDyeLotRolls))
                  updatedFuture.noOfDyeLotRollsReduced = (fs.noOfDyeLotRollsReduced || 0) + toReduce;
                  updatedFuture.tempReduced = 0;
                  updatedFuture.tempDye = selectedDate
                  moveGreige = moveGreige - toReduce
                  tempDye = true
                  updatedFuture.noOfDyeLotRolls = (fs?.noOfDyeLotRolls - toReduce)
                }
                return {
                  ...updatedFuture,
                  tempDye: tempDye ? selectedDate : fs?.tempDye,
                  tempFab: tempFab ? selectedDate : fs?.tempFab,
                  tempGreige: tempGreige ? selectedDate : fs?.tempGreige
                }
              });

              return { ...prev, stockSchedules: updated };
            }

            const isSample = orderType === "SAMPLE";

            const futureSchedule = schedules.find((s) => {
              const d = s.deliveryDate ? moment(s.deliveryDate).format("DD/MM/YYYY") : null;
              return (
                (isSample ? s.variantSku === item?.variantSku : s.swatchId === item?.swatchId) &&
                d === futureSelectedDate
              );
            });

            if (!futureSchedule) return prev;

            const movedRolls = futureSchedule.noOfRollOrdered || 0;
            const movedQty = futureSchedule.qty || 0;

            schedules = schedules.map((s) =>
              s.id === futureSchedule.id ? { ...s, noOfRollOrdered: 0, qty: 0 } : s
            );

            const existingIndex = schedules.findIndex((s) => {
              const d = s.deliveryDate ? moment(s.deliveryDate).format("DD/MM/YYYY") : null;
              return (
                (isSample ? s.variantSku === item?.variantSku : s.swatchId === item?.swatchId) &&
                d === selectedDate
              );
            });

            if (existingIndex !== -1) {
              const s = schedules[existingIndex];
              schedules[existingIndex] = {
                ...s,
                noOfRollOrdered: (s.noOfRollOrdered || 0) + movedRolls,
                qty: (s.qty || 0) + movedQty,
              };
            } else {
              const template = futureSchedule;
              schedules.push({
                id: `moved_${sku}_${Date.now()}`,
                variantSku: isSample ? sku : null,
                swatchId: isSample ? null : sku,
                deliveryDate: moment(selectedDate, "DD/MM/YYYY").toDate(),
                noOfRollOrdered: movedRolls,
                qty: movedQty,
                deliveryCreated: false,
                productVariantName: template.productVariantName || item?.productVariant?.name || null,
                poId: template.poId || prev.poId,
                stdKg: template.stdKg || 5,
                costPrice: template.costPrice || 1,
                initialCostPrice: template.initialCostPrice || 1,
                createdDate: Date.now(),
                updatedDate: Date.now(),
                status: "ACTIVE",
                createdBy: "USER-0009",
                updatedBy: "USER-0009",
                companyId: template.companyId || null,
                locationId: template.locationId || null,
              });
            }

            return { ...prev, stockSchedules: schedules };
          });

          const movedInputKey = `${sku}_${futureSelectedDate}`;
          setInputValues((prev) => ({ ...prev, [movedInputKey]: 0 }));
        };

        return (
          <Button
            onClick={() => handleAddToStock(sku, row.original)}
            style={{ backgroundColor: "#17a6b0ff", color: "white", padding: "0px 8px" }}
            disabled={currentValue < 1}
          >
            <div style={{ display: "flex", flexDirection: "row" }}>
              <span>ADD</span>
              <span style={{ display: "flex", fontSize: "10px", fontWeight: "lighter", color: "black", alignItems: "flex-end", marginLeft: "5px" }}> {currentValue} Rolls</span>
            </div>
          </Button>
        );
      },
    },
  ], [purchaseOrder, futureSelectedDate, selectedDate, orderType, activeTabTop, selectedStatusType, handleRollChange]);

  const displayDetails = useMemo(() => {
    const getTotalRollsForDate = (date) => {
      return stockSchedule.reduce((sum, s) => {
        const key = s.variantSku || s.swatchId;
        return sum + getRollsForDateFilter(date, key);
      }, 0);
    };

    const filteredDates = allDates.filter((date) => {
      const totalRolls = getTotalRollsForDate(date);
      if (totalRolls === 0) return false;

      const matchingSchedules = stockSchedule?.filter((s) => {
        const dDye = s.dyeLotDeliveryDate ? moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY") : null;
        const dFabric = s.fabricDeliveryDate ? moment(s.fabricDeliveryDate).format("DD/MM/YYYY") : null;
        const dGreige = s.greigeDeliveryDate ? moment(s.greigeDeliveryDate).format("DD/MM/YYYY") : null;
        const dNormal = s.deliveryDate ? moment(s.deliveryDate).format("DD/MM/YYYY") : null;

        return dDye === date || dFabric === date || dGreige === date || dNormal === date;
      });

      const hasUnprocessedRolls = matchingSchedules.some((s) => {
        const dDye = s.dyeLotDeliveryDate ? moment(s.dyeLotDeliveryDate).format("DD/MM/YYYY") : null;
        const dFabric = s.fabricDeliveryDate ? moment(s.fabricDeliveryDate).format("DD/MM/YYYY") : null;
        const dGreige = s.greigeDeliveryDate ? moment(s.greigeDeliveryDate).format("DD/MM/YYYY") : null;
        const dNormal = s.deliveryDate ? moment(s.deliveryDate).format("DD/MM/YYYY") : null;

        if (dDye === date && s.noOfDyeLotRolls > 0 && !s.dyeLotCreated) return true;
        if (dFabric === date && s.noOfFabricRolls > 0 && !s.fabricCreated) return true;
        if (dGreige === date && s.noOfGreigeRolls > 0 && !s.greigeCreated) return true;
        if (dNormal === date && s.qty > 0 && !s.deliveryCreated) return true;
        return false;
      });

      return hasUnprocessedRolls;
    });

    return [
      {
        type: "TextInput",
        label: "Purchase Type",
        name: "purchaseType",
        className: "input-salesfield",
        value: purchaseOrder?.orderType || "N/A",
        readOnly: true,
      },
      {
        type: "TextInput",
        label: "Vendor",
        name: "vendor",
        className: "input-salesfield",
        value: purchaseOrder?.vendor?.supplier || "N/A",
        readOnly: true,
      },
      {
        type: "TextInput",
        label: "Ship From",
        name: "billAddress",
        className: "input-salesfield",
        value: [
          purchaseOrder?.shipFrom?.address1,
          purchaseOrder?.shipFrom?.address2,
          purchaseOrder?.billLocation?.city,
        ]
          .filter(Boolean)
          .join(", ") || "N/A",
        readOnly: true,
      },
      {
        type: "TextInput",
        label: "Ship To",
        name: "shipAddress",
        className: "input-salesfield",
        value: [
          purchaseOrder?.shipLocation?.address,
          purchaseOrder?.shipLocation?.city,
          purchaseOrder?.shipLocation?.state,
        ]
          .filter(Boolean)
          .join(", ") || "N/A",
        readOnly: true,
      },
      {
        ...(activeTabTop === "ASN" && selectedStatusType === "NEW"
          ? {
            type: "B2BSelect",
            label: "Product Delivery On",
            name: "expectedDeliveryOn",
            className: "input-salesfield",
            placeholder: "Select a delivery date",
            data: filteredDates.map((d) => ({ value: d, label: d })),
            value: selectedDate,
            onChange: handleSelectedDateChange,
            clearable: true,
          }
          : {
            type: "TextInput",
            label: "Product Delivery On",
            name: "expectedDeliveryOn",
            className: "input-salesfield",
            value: purchaseOrder?.expectedDeliveryOn
              ? moment(purchaseOrder?.expectedDeliveryOn).format("DD/MM/YYYY")
              : "N/A",
            readOnly: true,
          }),
      },
      ...(activeTabTop === "ASN" && selectedStatusType === "NEW"
        ? [
          {
            type: "B2BSelect",
            label: "Future Product Delivery On",
            name: "expectedFutureDeliveryOn",
            className: "input-salesfield",
            placeholder: "Select a future delivery date",
            data: allDates
              .filter((d) => moment(d, "DD/MM/YYYY").isAfter(moment(selectedDate, "DD/MM/YYYY")))
              .map((d) => ({ value: d, label: d })),
            value: futureSelectedDate,
            onChange: setFutureSelectedDate,
            clearable: true,
          },
        ]
        : []),
    ];
  }, [purchaseOrder, selectedDate, allDates, futureSelectedDate, activeTabTop, selectedStatusType]);
  const isStdKgValid = useMemo(() => {
    if (!purchaseOrder?.items?.length) return false;

    return purchaseOrder.items.every((item) => {
      const val = Number(item?.stdKg);

      // must be a number and >= 1
      return item?.stdKg !== "" && !isNaN(val) && val >= 1;
    });
  }, [purchaseOrder?.items]);
  const buttonArr = useMemo(
    () => [
      {
        name: "Delivery Schedule",
        color: "#ab1fa4ff",
        style: {
          marginTop: isMobile ? "10px" : "0px",
          display: activeTabTop === "ASN" || activeTabTop === "GE" || activeTabTop === "GRN" || selectedStatusType === "PENDING" || selectedStatusType === "REJECTED" ? "none" : ""
        },
        onClick: purchaseOrder?.stockSchedules?.length > 0
          ? () => setIsScheduleModalOpen(true)
          : () => setIsScheduleFormOpen(true),
      },
      ...((selectedStatusType === "PENDING" && activeTabTop === "PO")
        ? [
          {
            name: "Update Std kg/Qty",
            color: "#ab1fa4ff",
            style: {
              marginTop: isMobile ? "10px" : "0px",
              opacity: isStdKgValid ? 1 : 0.5,
              cursor: isStdKgValid ? "pointer" : "not-allowed",
            },
            disabled: !isStdKgValid,
            onClick: handleSaveUnApprovedPo,
          }
        ]
        : []),
    ],
    [purchaseOrder, isMobile, selectedStatusType, handleSaveUnApprovedPo, activeTabTop]
  );

  const amountDetails = useMemo(
    () => [
      {
        type: "TextInput",
        label: "TOTAL AMOUNT",
        name: "totalAmount",
        value: (
          (parseFloat(purchaseOrder?.grossTotal) || 0) +
          (parseFloat(purchaseOrder?.adjustedAmount) || 0)
        ).toFixed(2),
        readOnly: true,
        className: "total-amount",
        highlight: true,
      },
    ],
    [purchaseOrder]
  );

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1rem", marginBottom: "0.5rem" }}>
        <h2 style={{ display: "flex", alignItems: "center", fontSize: "20px", fontWeight: "bolder", marginLeft: "1rem" }}>{activeTabTop === "PO" ? "Purchase Order" : activeTabTop === "ASN" ? "Advance Shippment Node" : activeTabTop === "GE" ? "Gate Entry" : activeTabTop === "GRN" ? "GRN" : ""} </h2>
        <div style={{ display: "flex", marginTop: "1rem", gap: "1rem", marginBottom: "0.5rem" }}>
          {(activeTabTop === "PO" && (selectedStatusType === 'PENDING' || selectedStatusType === 'NEW')) && <B2BButton
            onClick={() => setIsCancelModalOpen(true)}
            color="#d13838"
            name="Reject PO"
          />}
          <B2BButton
            style={{ color: "#000", marginRight: "1rem" }}
            onClick={() =>
              navigate(`/Po-Wholesale`, {
                state: { activeHeaderBack: activeTabTop, selectedStatusTypeFromBack: selectedStatusType },
              })
            }
            title="Back"
            leftSection={<IconArrowLeft size={15} />}
            color="#c9e8b8"
            name="Back"
          />
        </div>
      </div>
      <SalesHeader fields={fields} buttonArr={buttonArr} />
      <SalesHeaderTable inputFields={displayDetails} />
      <SalesOrderTable
        className="delivery-schedule-table"
        columns={productColumns}
        handleSaveProduct={handleSaveProduct}
        data={
          activeTabTop === "PO"
            ? purchaseOrder?.items || []
            : activeTabTop === "ASN" && selectedStatusType === "NEW"
              ? filteredItems
              : activeTabTop === "ASN" && selectedStatusType != "NEW"
                ? purchaseOrder?.items || []
                : activeTabTop === "GE"
                  ? purchaseOrder?.items || []
                  : activeTabTop === "GRN"
                    ? purchaseOrder?.items || []
                    : []
        }
        setPurchaseOrder={setPurchaseOrder}
        Stockdata2={purchaseOrder?.stockSchedules || []}
        purchaseOrder={purchaseOrder}
        canSave={canSave}
        selectedStatusType={selectedStatusType}
        activeTabTop={activeTabTop}
        orderType={orderType}
        readOnly={selectedStatusType === "PENDING"}
        title="Product Details"
      />
      {activeTabTop === "ASN" && selectedStatusType === "NEW" && (
        <SalesOrderTableFuture
          columns={futureProductColumns}
          handleSaveProduct={handleSaveProduct}
          data={futurefilteredItems}
          setPurchaseOrder={setPurchaseOrder}
          Stockdata2={purchaseOrder?.stockSchedules || []}
          purchaseOrder={purchaseOrder}
          readOnly={false}
          title="Future Product Details"
        />
      )}
      <DeliveryScheduleModal
        opened={isScheduleModalOpen}
        onClose={() => setIsScheduleModalOpen(false)}
        purchaseOrder={purchaseOrder}
        orderType={orderType}
        setPurchaseOrder={setPurchaseOrder}
      />
      <DeliveryScheduleForm
        opened={isScheduleFormOpen}
        setPurchaseOrder={setPurchaseOrder}
        orderType={orderType}
        onClose={() => setIsScheduleFormOpen(false)}
        purchaseOrder={purchaseOrder}
      />
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1rem" }}>
        <div style={{ display: isMobile ? "block" : "flex", flex: 3, justifyContent: "flex-end" }}>
          <SalesOrderPayment financialBreakdown={amountDetails} />
        </div>
      </div>
      <Logistics
        activeTabTop={activeTabTop}
        selectedStatusType={selectedStatusType}
        purchaseOrder={purchaseOrder}
      />

      <GeDetails
        activeTabTop={activeTabTop}
        selectedStatusType={selectedStatusType}
        purchaseOrder={purchaseOrder}
      />
      <Modal
        opened={isCancelModalOpen}
        onClose={() => setIsCancelModalOpen(false)}
        title="Confirm Rejection"
        centered
      >
        <Text size="sm" mb="lg">
          Are you sure you want to Reject this Purchase Order
        </Text>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1.5rem' }}>
          <B2BButton variant="default" onClick={() => setIsCancelModalOpen(false)} name="No" />
          <B2BButton color="red" onClick={handleCancelConfirm} name="Reject PO" />
        </div>
      </Modal>
    </div>
  );
};

export default PurchaseView;